import * as propertyTypes from "../property_types.js"

export class UiNumericTextbox extends propertyTypes.AppBaseComponentProps {

    private minMetadata = new propertyTypes.TextProperty("min", "Min");
    public min: string;

    private maxMetadata = new propertyTypes.TextProperty("max", "Max");
    public max: string;

    private spinnersMetadata = new propertyTypes.CheckBoxProperty("spinners", "Spinners");
    public spinners: boolean;

    private formatMetadata = new propertyTypes.TextProperty("format", "Format");
    public format: string;

    private decimalsMetadata = new propertyTypes.TextProperty("decimals", "Decimals");
    public decimals: string;

    private modelUnityMetadata = new propertyTypes.TextProperty("modelUnity", "Model unit");
    public modelUnity: string;

    private metadataAll: propertyTypes.BaseProperty[];
    constructor() {
        super();
        const baseMetaData = super.getMetadata();
        this.metadataAll = baseMetaData.concat([this.minMetadata, this.maxMetadata, this.decimalsMetadata, this.spinnersMetadata, this.formatMetadata, this.modelUnityMetadata]);
    };

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.metadataAll;
    }
}